import Web3 from 'web3';
import store from "../store";
import Toast from "vant/lib/toast";
import 'vant/lib/toast/style';

import {
    BigNumber,
    BigNumberStr,
    BigNumberMul,
    BigNumberDiv,
    BigNumberAdd,
    BigNumberSub,
} from '../tools/index';

import { connectMetaMask, connectOKX, connectTP } from './walletConnectTools';

import abiERC20 from '../abi/abiERC20';
import abiERC721 from '../abi/abiERC721';
import abiERC1155 from '../abi/abiERC1155';
import abiRWAART from '../abi/abiRWAART';
import abiArtLaunch from '../abi/abiArtLaunch';
import abiPancakeFactory from '../abi/abiPancakeFactory';
import abiPair from '../abi/abiPair';
import abiChainlinkOracle from '../abi/abiChainlinkOracle';

import {
    debug,
} from "@/config";

import {
    rwaartAddress,
} from "@/tools/projectConfig";

import transfer from "@/tools/transfer";

let queryWeb3;
const initQueryWeb3 = async () => {
    queryWeb3 = new Web3('https://rpc.ankr.com/bsc/4a8ded80e17d5d9c30e38d5c0147182879f4f1b804dd9668be31242fbef2d73a');
    if (debug) {
        queryWeb3 = new Web3('https://bsc-testnet.drpc.org');
    } else {
        queryWeb3 = new Web3('https://rpc.ankr.com/bsc/4a8ded80e17d5d9c30e38d5c0147182879f4f1b804dd9668be31242fbef2d73a');
    }
}
// 初始化
initQueryWeb3().then((res) => {});

const initWeb3hooks = async () => {
    if (sessionStorage.getItem("walletType")) {
        store.commit('setState', {
            walletType: parseInt(sessionStorage.getItem("walletType"))
        })
    }

    if (parseInt(store.state.walletType) === 0) {
        await connectOKX();
    } else if (parseInt(store.state.walletType) === 1) {
        await connectMetaMask();
    } else if (parseInt(store.state.walletType) === 2) {
        await connectTP();
    }

    await initParams();
};

const initWeb3 = async () => {
    try {
        await initWeb3hooks();

        await transfer.$emit("initPageData");
    } catch (err) {
        Toast.fail(err);
    }
}

let account = localStorage.getItem('accounts');
if (account) {
    initWeb3().then(res => {});
} else {
    initQueryWeb3().then(res => {});
}

const initParams = async () => {
    if (parseInt(store.state.walletType) === 0) {
        if (window.okxwallet) {
            if (debug) {
                try {
                    await (window.okxwallet).request({
                        method: 'wallet_switchEthereumChain',
                        params: [{
                            chainId: Web3.utils.numberToHex(97)
                        }]
                    })
                } catch (e) {
                    if ((e).code === 4902) {
                        try {
                            await (window.okxwallet).request({
                                method: 'wallet_addEthereumChain',
                                params: [
                                    {
                                        chainId: Web3.utils.numberToHex(97),
                                        chainName: 'BSC-Testnet',
                                        nativeCurrency: {
                                            name: 'tBNB',
                                            symbol: 'tBNB',
                                            decimals: 18
                                        },
                                        rpcUrls: ['https://bsc-testnet.drpc.org'],
                                        blockExplorerUrls: ['https://testnet.bscscan.com']
                                    }
                                ]
                            })
                        } catch (err) {
                            console.log(err);
                        }
                    } else if ((e).code === 4001) {
                        return;
                    }
                }
            } else {
                try {
                    await (window.okxwallet).request({
                        method: 'wallet_switchEthereumChain',
                        params: [{
                            chainId: Web3.utils.numberToHex(56)
                        }]
                    })
                } catch (e) {
                    if ((e).code === 4902) {
                        try {
                            await (window.okxwallet).request({
                                method: 'wallet_addEthereumChain',
                                params: [
                                    {
                                        chainId: Web3.utils.numberToHex(56),
                                        chainName: 'BSC-Main',
                                        nativeCurrency: {
                                            name: 'BNB',
                                            symbol: 'BNB',
                                            decimals: 18
                                        },
                                        rpcUrls: [
                                            'https://rpc.ankr.com/bsc/4a8ded80e17d5d9c30e38d5c0147182879f4f1b804dd9668be31242fbef2d73a',
                                            'https://rpc.ankr.com/bsc/a2a129770d47c473719e4dc326d987a62bda47f0431cb80066e33da710465192'
                                        ],
                                        blockExplorerUrls: ['https://bscscan.com']
                                    }
                                ]
                            })
                        } catch (err) {
                            console.log(err);
                        }
                    } else if ((e).code === 4001) {
                        return;
                    }
                }
            }
        }
    } else if (parseInt(store.state.walletType) === 1) {
        if (window.ethereum) {
            if (debug) {
                try {
                    await (window.ethereum).request({
                        method: 'wallet_switchEthereumChain',
                        params: [{
                            chainId: Web3.utils.numberToHex(97)
                        }]
                    })
                } catch (e) {
                    if ((e).code === 4902) {
                        try {
                            await (window.ethereum).request({
                                method: 'wallet_addEthereumChain',
                                params: [
                                    {
                                        chainId: Web3.utils.numberToHex(97),
                                        chainName: 'BSC-Testnet',
                                        nativeCurrency: {
                                            name: 'tBNB',
                                            symbol: 'tBNB',
                                            decimals: 18
                                        },
                                        rpcUrls: ['https://bsc-testnet.drpc.org'],
                                        blockExplorerUrls: ['https://testnet.bscscan.com']
                                    }
                                ]
                            })
                        } catch (err) {
                            console.log(err);
                        }
                    } else if ((e).code === 4001) {
                        return;
                    }
                }
            } else {
                try {
                    await (window.ethereum).request({
                        method: 'wallet_switchEthereumChain',
                        params: [{
                            chainId: Web3.utils.numberToHex(56)
                        }]
                    })
                } catch (e) {
                    if ((e).code === 4902) {
                        try {
                            await (window.ethereum).request({
                                method: 'wallet_addEthereumChain',
                                params: [
                                    {
                                        chainId: Web3.utils.numberToHex(56),
                                        chainName: 'BSC-Main',
                                        nativeCurrency: {
                                            name: 'BNB',
                                            symbol: 'BNB',
                                            decimals: 18
                                        },
                                        rpcUrls: [
                                            'https://rpc.ankr.com/bsc/4a8ded80e17d5d9c30e38d5c0147182879f4f1b804dd9668be31242fbef2d73a',
                                            'https://rpc.ankr.com/bsc/a2a129770d47c473719e4dc326d987a62bda47f0431cb80066e33da710465192'
                                        ],
                                        blockExplorerUrls: ['https://bscscan.com']
                                    }
                                ]
                            })
                        } catch (err) {
                            console.log(err);
                        }
                    } else if ((e).code === 4001) {
                        return;
                    }
                }
            }
        }
    } else if (parseInt(store.state.walletType) === 2) {
        if (window.tokenpocket.ethereum) {
            if (debug) {
                try {
                    await (window.tokenpocket.ethereum).request({
                        method: 'wallet_switchEthereumChain',
                        params: [{
                            chainId: Web3.utils.numberToHex(97)
                        }]
                    })
                } catch (e) {
                    if ((e).code === 4902) {
                        try {
                            await (window.tokenpocket.ethereum).request({
                                method: 'wallet_addEthereumChain',
                                params: [
                                    {
                                        chainId: Web3.utils.numberToHex(97),
                                        chainName: 'BSC-Testnet',
                                        nativeCurrency: {
                                            name: 'tBNB',
                                            symbol: 'tBNB',
                                            decimals: 18
                                        },
                                        rpcUrls: ['https://bsc-testnet.drpc.org'],
                                        blockExplorerUrls: ['https://testnet.bscscan.com']
                                    }
                                ]
                            })
                        } catch (err) {
                            console.log(err);
                        }
                    } else if ((e).code === 4001) {
                        return;
                    }
                }
            } else {
                try {
                    await (window.tokenpocket.ethereum).request({
                        method: 'wallet_switchEthereumChain',
                        params: [{
                            chainId: Web3.utils.numberToHex(56)
                        }]
                    })
                } catch (e) {
                    if ((e).code === 4902) {
                        try {
                            await (window.tokenpocket.ethereum).request({
                                method: 'wallet_addEthereumChain',
                                params: [
                                    {
                                        chainId: Web3.utils.numberToHex(56),
                                        chainName: 'BSC-Main',
                                        nativeCurrency: {
                                            name: 'BNB',
                                            symbol: 'BNB',
                                            decimals: 18
                                        },
                                        rpcUrls: [
                                            'https://rpc.ankr.com/bsc/4a8ded80e17d5d9c30e38d5c0147182879f4f1b804dd9668be31242fbef2d73a',
                                            'https://rpc.ankr.com/bsc/a2a129770d47c473719e4dc326d987a62bda47f0431cb80066e33da710465192'
                                        ],
                                        blockExplorerUrls: ['https://bscscan.com']
                                    }
                                ]
                            })
                        } catch (err) {
                            console.log(err);
                        }
                    } else if ((e).code === 4001) {
                        return;
                    }
                }
            }
        }
    }

    console.log('Connection successful');
};


const popupPrompts = (type, hashCode) => {
    store.commit('setState', {
        toastShow: true,
        toastShowType: type,
        transactionHash: hashCode
    })
};

export const getBalance = async (address) => {
    return new Promise(async (resolve, reject) => {
        try {
            const res = await new queryWeb3.eth.getBalance(address);
            resolve(res);
        } catch (err) {
            reject(err);
        }
    })
}

export const getIndexBlock = async () => {
    return new Promise(async (resolve, reject) => {
        try {
            const res = await new queryWeb3.eth.getBlockNumber();
            resolve(res);
        } catch (err) {
            reject(err);
        }
    })
}

export const erc20BasicPublicCall = async (address, methods, params) => {
    return await publicCall(new window.globalWeb3.eth.Contract(abiERC20, address), methods, params);
}

export const erc20BasicPublicSend = async (address, methods, params) => {
    return await publicSend(new window.globalWeb3.eth.Contract(abiERC20, address), methods, params);
}

/**
 * 创建项目
 * @param params
 * @returns {Promise<unknown>}
 */
export const createProject = async (params) => {
    let json = {
        from: store.state.accounts[0],
        gas: 2000000
    }

    return await publicSend(new window.globalWeb3.eth.Contract(abiRWAART, rwaartAddress), "createProject", params, json);
}

/**
 * 获取过滤事件
 * @param projectId
 * @param blockNum
 * @returns {Promise<EventData[]>}
 */
export const getFilteredEvents = async (projectId, blockNum) => {
    try {
        const events = await new queryWeb3.eth.Contract(abiRWAART, rwaartAddress).getPastEvents('ProjectCreated', {
            filter: {
                projectId: projectId
            },
            fromBlock: blockNum,
            toBlock: 'latest'
        });

        return events;
    } catch (error) {
        console.error('Error fetching filtered events:', error);
    }
}

/**
 * 拍卖
 * @param params
 * @param value
 * @returns {Promise<unknown>}
 */
export const bidding = async (params, value) => {
    let json = {
        from: store.state.accounts[0],
        value: BigNumberMul(value, 1e18),
        gas: 2000000
    }

    return await publicSend(new window.globalWeb3.eth.Contract(abiRWAART, rwaartAddress), "bidding", params, json);
}

/**
 * 获取下一个项目Id
 * @returns {Promise<unknown>}
 */
export const nextProjectId = async () => {
    return await publicCall(new window.globalWeb3.eth.Contract(abiRWAART, rwaartAddress), "nextProjectId");
}


/**
 * 获取项目Mint信息
 * @param launchAddress
 * @param params
 * @returns {Promise<unknown>}
 */
export const getTokenInfo = async (launchAddress, params) => {
    return await publicCall(new window.globalWeb3.eth.Contract(abiArtLaunch, launchAddress), "tokenInfo", params);
}

/**
 * 获取用户Mint信息
 * @param launchAddress
 * @param params
 * @returns {Promise<unknown>}
 */
export const getUserInfo = async (launchAddress, params) => {
    return await publicCall(new window.globalWeb3.eth.Contract(abiArtLaunch, launchAddress), "userInfo", params);
}

/**
 * 参与抵押 Mint
 * @param launchAddress
 * @param params
 * @returns {Promise<unknown>}
 */
export const onDepBuCoin = async (launchAddress, params) => {
    return await publicSend(new window.globalWeb3.eth.Contract(abiArtLaunch, launchAddress), "depBuCoin", params);
}

/**
 * 获取参与抵押事件
 * @param launchAddress
 * @param projectId
 * @param user
 * @param fromBlock
 * @param toBlock
 * @returns {Promise<EventData[]>}
 */
export const getDepBuCoin = async (launchAddress, projectId, user, fromBlock, toBlock) => {
    try {
        const events = await new queryWeb3.eth.Contract(abiArtLaunch, launchAddress).getPastEvents('DepBuCoin', {
            filter: {
                id: projectId,
                // user: user
            },
            fromBlock: fromBlock,
            toBlock: toBlock
        });

        return events;
    } catch (error) {
        console.error('Error fetching filtered events:', error);
    }
}


/**
 * 发射
 * @param params
 * @returns {Promise<unknown>}
 */
export const onLaunchPad = async (params) => {
    return await publicSend(new window.globalWeb3.eth.Contract(abiRWAART, rwaartAddress), "deploy", params);
}

/**
 * 获取LP池地址(v2)
 * @param tokenAddress
 * @returns {Promise<*|null>}
 */
export const getLpTokenPoolAddress = async (tokenAddress) => {
    try {
        // WBNB地址 (BSC主网)
        const WBNB_ADDRESS = '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c';

        // PancakeSwap Factory合约地址 (BSC主网)
        const PANCAKE_FACTORY_ADDRESS = '0xcA143Ce32Fe78f1f7019d7d551a6402fC5350c73';

        // 确保tokenAddress存在
        if (!tokenAddress) {
            console.error('Token address is not set');
            return null;
        }

        // 获取LP池地址
        // 注意：token0和token1需要按地址排序
        let token0, token1;
        if (tokenAddress.toLowerCase() < WBNB_ADDRESS.toLowerCase()) {
            token0 = tokenAddress;
            token1 = WBNB_ADDRESS;
        } else {
            token0 = WBNB_ADDRESS;
            token1 = tokenAddress;
        }

        return await publicCall(new window.globalWeb3.eth.Contract(abiPancakeFactory, PANCAKE_FACTORY_ADDRESS), "getPair", [token0, token1]);
    } catch (error) {
        console.error('Error getting LP pool address:', error);
        return null;
    }
}

export const getBNBPriceFromOracle = async () => {
    try {
        // 使用Chainlink预言机获取BNB/USD价格
        const chainlinkOracleAddress = '0x0567F2323251f0Aab15c8dFb1967E4e8A7D42aeE'; // BSC上的Chainlink BNB/USD预言机

        const bnbPrice = await publicCall(
            new window.globalWeb3.eth.Contract(abiChainlinkOracle, chainlinkOracleAddress),
            "latestAnswer",
            []
        );

        return BigNumberDiv(bnbPrice, 1e8, 6);
    } catch (error) {
        console.error('Error getting BNB price from oracle:', error);

        // 备用方案：使用PancakeSwap的BNB/BUSD交易对
        const bnbBusdPair = '0x58F876857a02D6762E0101bb5C46A8c1ED44Dc16';

        const reserves = await publicCall(
            new window.globalWeb3.eth.Contract(abiPair, bnbBusdPair),
            "getReserves",
            []
        );

        const bnbReserve = reserves._reserve0;
        const busdReserve = reserves._reserve1;

        return busdReserve / bnbReserve;
    }
}

export const getTokenPriceAndLiquidity = async (tokenAddress, lpAddress, bnbPrice) => {
    try {
        // 获取储备量
        const reserves = await publicCall(
            new window.globalWeb3.eth.Contract(abiPair, lpAddress),
            "getReserves",
            []
        );
        const token0 = await publicCall(
            new window.globalWeb3.eth.Contract(abiPair, lpAddress),
            "token0",
            []
        );

        // 确定代币在交易对中的位置
        const isToken0 = token0.toLowerCase() === tokenAddress.toLowerCase();
        const tokenReserve = isToken0 ? reserves._reserve0 : reserves._reserve1;
        const bnbReserve = isToken0 ? reserves._reserve1 : reserves._reserve0;

        // 计算价格 (假设交易对是TOKEN/BNB)
        const priceInBNB = bnbReserve / tokenReserve;

        return {
            tokenPrice: BigNumberMul(priceInBNB, bnbPrice, 18),
            poolLiquidity: BigNumberDiv((bnbReserve * 2 * bnbPrice), 1e18, 3)
        };
    } catch (error) {
        console.error('Error calculating token price:', error);
        return null;
    }
}

export const getMarketCap = async (tokenAddress, lpAddress, price) => {
    try {
        if (!price) return null;

        // 获取代币总供应量
        const totalSupply = await publicCall(
            new window.globalWeb3.eth.Contract(abiERC20, tokenAddress),
            "totalSupply",
            []
        );
        let decimals = await publicCall(
            new window.globalWeb3.eth.Contract(abiERC20, tokenAddress),
            "decimals",
            []
        );

        decimals = parseInt(decimals ? decimals.toString() : 18);

        // 计算市值
        return price * (totalSupply / Math.pow(10, decimals));
    } catch (error) {
        console.error('Error calculating market cap:', error);
        return null;
    }
}


// public send
export const publicSend = async (contract, methods, params = [], send_json = {
    from: store.state.accounts[0],
    // gas: 2000000
    // gasPrice: 500000000 // 0.5 gwei
}) => {
    return new Promise(async (resolve, reject) => {
        try {
            store.commit("setState", {
                toastShow: true,
                toastShowType: 0,
            });

            // console.log(contract, methods, params);

            await contract.methods[methods](...params).call(send_json);

            const res = await contract.methods[methods](...params).send(
                send_json
            ).on('transactionHash', function (hash) {
                popupPrompts(1, hash);
            }).on('confirmation', function (confirmationNumber, receipt) {
                store.commit('setState', {
                    transactionHash: receipt.transactionHash,
                })
            }).on('receipt', function (receipt) {
                popupPrompts(2, receipt.transactionHash);
            });
            resolve(res);
        } catch (err) {
            store.commit('setState', {
                transactionHash: '',
            })
            if (err.code === 4001) {
                store.commit('setState', {
                    toastShow: true,
                    toastShowType: 4,
                })
            } else {
                store.commit('setState', {
                    toastShow: true,
                    toastShowType: 3,
                })
            }
            reject(err);
        }
    })
}

// public call
export const publicCall = async (contract, methods, params = []) => {
    return new Promise(async (resolve, reject) => {
        try {
            // console.log(contract, methods, params);
            const res = await contract.methods[methods](...params).call({ from: store.state.accounts[0] });
            resolve(res);
        } catch (err) {
            reject(err);
        }
    })
}

export {
    initWeb3,
    initWeb3hooks,
    initParams,
    popupPrompts,
    initQueryWeb3,
}
